const ReportTypes = {
	COUPON_TRANSACTIONS: {
		REQUEST: 'REPORT_COUPON_TRANSACTIONS_REQUEST',
		SUCCESS: 'REPORT_COUPON_TRANSACTIONS_SUCCESS',
		FAILURE: 'REPORT_COUPON_TRANSACTIONS_FAILURE',
		CLEAR: 'REPORT_COUPON_TRANSACTIONS_CLEAR',
	},
	COUPONS_TRANSACTIONS_OVERVIEW: {
		REQUEST: 'REPORT_COUPONS_TRANSACTIONS_OVERVIEW_REQUEST',
		SUCCESS: 'REPORT_COUPONS_TRANSACTIONS_OVERVIEW_SUCCESS',
		FAILURE: 'REPORT_COUPONS_TRANSACTIONS_OVERVIEW_FAILURE',
		CLEAR: 'REPORT_COUPONS_TRANSACTIONS_OVERVIEW_CLEAR',
	},
	PAYMENT_REQUEST_TRANSACTIONS: {
		REQUEST: 'REPORT_PAYMENT_REQUEST_TRANSACTIONS_REQUEST',
		SUCCESS: 'REPORT_PAYMENT_REQUEST_TRANSACTIONS_SUCCESS',
		FAILURE: 'REPORT_PAYMENT_REQUEST_TRANSACTIONS_FAILURE',
		CLEAR: 'REPORT_PAYMENT_REQUEST_TRANSACTIONS_CLEAR',
	},
	PAYMENT_REQUEST_TRANSACTIONS_OVERVIEW: {
		REQUEST: 'REPORT_PAYMENT_REQUEST_TRANSACTIONS_OVERVIEW_REQUEST',
		SUCCESS: 'REPORT_PAYMENT_REQUEST_TRANSACTIONS_OVERVIEW_SUCCESS',
		FAILURE: 'REPORT_PAYMENT_REQUEST_TRANSACTIONS_OVERVIEW_FAILURE',
		CLEAR: 'REPORT_PAYMENT_REQUEST_TRANSACTIONS_OVERVIEW_CLEAR',
	},
	REPORT_TRANSACTIONS_PACKAGE: {
		REQUEST: 'REPORT_TRANSACTIONS_PACKAGE_REQUEST',
		SUCCESS: 'REPORT_TRANSACTIONS_PACKAGE_SUCCESS',
		FAILURE: 'REPORT_TRANSACTIONS_PACKAGE_FAILURE',
		CLEAR: 'REPORT_TRANSACTIONS_PACKAGE_CLEAR',
	},
	REPORT_CHART_PACKAGE: {
		REQUEST: 'REPORT_CHART_PACKAGE_REQUEST',
		SUCCESS: 'REPORT_CHART_PACKAGE_SUCCESS',
		FAILURE: 'REPORT_CHART_PACKAGE_FAILURE',
		CLEAR: 'REPORT_CHART_PACKAGE_CLEAR',
	},
	REPORT_CHART_PACKAGE_OFFCB: {
		REQUEST: 'REPORT_CHART_PACKAGE_OFFCB_REQUEST',
		SUCCESS: 'REPORT_CHART_PACKAGE_OFFCB_SUCCESS',
		FAILURE: 'REPORT_CHART_PACKAGE_OFFCB_FAILURE',
		CLEAR: 'REPORT_CHART_PACKAGE_OFFCB_CLEAR',
	},
	REPORT_TRANSACTIONS_PACKAGE_OFFCB: {
		REQUEST: 'REPORT_TRANSACTIONS_PACKAGE_OFFCB_REQUEST',
		SUCCESS: 'REPORT_TRANSACTIONS_PACKAGE_OFFCB_SUCCESS',
		FAILURE: 'REPORT_TRANSACTIONS_PACKAGE_OFFCB_FAILURE',
		CLEAR: 'REPORT_TRANSACTIONS_PACKAGE_OFFCB_CLEAR',
	},
};

export default ReportTypes;
